import { __awaiter, __generator } from 'tslib';
import React__default, { useRef } from 'react';
import { CartContext } from '../../../context/CartContext.esm.js';
import { useNvModal, NvModal } from '@invitae/ids-react';
import modalStyles from '../../ModalBuilder.module.esm.js';

var FulfillGenesInRemainingGroupsModal = function (_a) {
    var genes = _a.genes;
    var _b = React__default.useContext(CartContext), addToCart = _b.addToCart, toggleCustomModalForm = _b.toggleCustomModalForm;
    var modalRef = useRef(null);
    var closeModalDialog = useNvModal(modalRef).closeModalDialog;
    var onCloseHandler = React__default.useCallback(function () {
        toggleCustomModalForm({});
    }, [toggleCustomModalForm]);
    var onSaveHandler = React__default.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            addToCart(genes.map(function (g) { return g.code; }));
            onCloseHandler();
            closeModalDialog();
            return [2 /*return*/];
        });
    }); }, [genes, closeModalDialog, onCloseHandler, addToCart]);
    return (React__default.createElement(NvModal, { classes: {
            modal: modalStyles.modal,
        }, defaultOpen: true, headerText: "Wait!", isDismissible: true, onDismiss: onCloseHandler, onPrimaryButtonClicked: onSaveHandler, onSecondaryButtonClicked: onCloseHandler, primaryButtonText: "Yes", ref: modalRef, secondaryButtonText: "No", showCloseButton: true, type: "information" },
        React__default.createElement("p", { "data-testid": "gene-list" },
            "The following gene(s) can be fulfilled on the remaining order group(s): ",
            genes.map(function (g) { return g.name; }).join(', '),
            "."),
        React__default.createElement("p", null, "Would you like to keep the gene(s) in your order?")));
};

export { FulfillGenesInRemainingGroupsModal as default };
//# sourceMappingURL=FulfillGenesInRemainingGroupsModal.esm.js.map
